import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ActiveGuaranteesDetailWithLoanInFlowView from "./ActiveGuaranteesDetailWithLoanInFlowView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {dateDDMMYYDataTableTemplate} from "../../../utils/formatters/Date";
import {
    amountDataTableTemplate,
    numberWithCommaDataTableTemplate,
    percentDataTableTemplate,
    priceDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";

export default class ActiveGuaranteesDetailWithLoanInFlowContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "consultDate", header: "Fecha Consulta", body: dateDDMMYYDataTableTemplate},
            {field: "loanId", header: "Folio", style: {textAlign: 'right', width: '100px'}},
            {field: "concertedDate", header: "Fecha Concert", body: dateDDMMYYDataTableTemplate},
            {field: "valueDate", header: "Fecha Valor", body: dateDDMMYYDataTableTemplate},
            {field: "concertedTime", header: "Hora Concertación"},
            {field: "maturityDate", header: "Fecha Vencimiento", body: dateDDMMYYDataTableTemplate},
            {
                field: "maturity",
                header: "Plazo",
                style: {textAlign: 'right', width: '50px'},
                body: numberWithCommaDataTableTemplate
            },
            {field: "lender", header: "PTM"},
            {field: "lenderAccount", header: "Cuenta PTM"},
            {field: "borrower", header: "PTT"},
            {field: "instrument", header: "Emisora"},
            {field: "valueType", header: "Clave"},
            {field: "serial", header: "Serie"},
            {field: "coupon", header: "Cupón"},
            {
                field: "titles",
                header: "Títulos",
                style: {textAlign: 'right', width: '100px'},
                body: numberWithCommaDataTableTemplate
            },
            {field: "currency", header: "Moneda"},
            {
                field: "price",
                header: "Precio",
                style: {textAlign: 'right', width: '100px'},
                body: priceDataTableTemplate
            },
            {
                field: "surcharge",
                header: "Sobretasa",
                style: {textAlign: 'right', width: '70px'},
                body: rateMultipliedByOneHundredDataTableTemplate
            },
            {
                field: "amount",
                header: "Importe",
                style: {textAlign: 'right', width: '100px'},
                body: amountDataTableTemplate
            },
            {
                field: "rate",
                header: "Tasa",
                style: {textAlign: 'right', width: '60px'},
                body: rateMultipliedByOneHundredDataTableTemplate
            },
            {
                field: "reward",
                header: "Premio",
                style: {textAlign: 'right', width: '100px'},
                body: amountDataTableTemplate
            },
            {field: "status", header: "Estatus", style: {textAlign: 'left', width: '60px'}},
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            filters: {
                guaranteeCheck: true,
                isinColumn: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            dataReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        this.setState({
            filters: {
                guaranteeCheck: false,
                isinColumn: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
        });
    }

    onChangeFilters(event) {
        let colsAux = this.state.cols;
        let filtersAux = this.state.filters;

        switch (event.target.name) {
            case "isinColumn":
                event.checked ?
                    colsAux.splice(14, 0,
                        {field: "isin", header: "ISIN"}) :
                    colsAux.splice(14, 1);
                filtersAux[event.target.name] = event.checked;
                break;
            case "guaranteeCheck":
                filtersAux[event.target.name] = event.checked;
                break;
            case "startDate":
                filtersAux[event.target.name] = event.target.value;
                filtersAux['finalDate'] = event.target.value;
                break;
            default:
                filtersAux[event.target.name] = event.target.value;
                break;
        }

        this.setState({
            cols: colsAux,
            filters: filtersAux,
        });
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.guaranteeIntradayReportList;
        return (
            <DataTable
                value={guaranteesItems}
                responsive={true}
                resizableColumns={true}
                columnResizeMode={"fit"}>
                <Column field="insertDate" header="Fecha" style={{textAlign: 'left'}} body={dateDDMMYYDataTableTemplate}
                        sortable={true}/>
                <Column field="origin" header="Origen" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="type" header="Tipo" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="currency" header="Moneda" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="instrument" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="valueType" header="Clave" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="serial" header="Serie" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="coupon" header="Cupón" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="borrowerAccount" header="Cuenta PTT" style={{textAlign: 'left'}} sortable={true}/>
                <Column field="titles" header="Títulos" style={{textAlign: 'right'}} sortable={true}
                        body={numberWithCommaDataTableTemplate}/>
                <Column field="price" header="Precio" style={{textAlign: 'right'}} sortable={true}
                        body={priceDataTableTemplate}/>
                <Column field="guaranteedAmount" header="Imp. Garantizado" style={{textAlign: 'right'}}
                        body={amountDataTableTemplate}
                        sortable={true}/>
                <Column field="totalGuaranteed" header="Tot. Garantizado" style={{textAlign: 'right'}} sortable={true}
                        body={amountDataTableTemplate}/>
                <Column field="guaranteedPercent" header="% Garantizado" style={{textAlign: 'right'}}
                        body={percentDataTableTemplate}
                        sortable={true}/>
            </DataTable>

        );
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true);
        this.setState({disabledSearchButton:true});

        this.reportsService.getIntradayReport(
            this.state.filters.startDate.getFullYear() + "-" +
            ("0" + (this.state.filters.startDate.getMonth() * 1 + 1)).slice(-2) + "-" +
            ("0" + this.state.filters.startDate.getDate()).slice(-2),
            localStorage.getItem("institution") === "Interno" ? 0 : localStorage.getItem("institutionId"),
            this.state.filters.guaranteeCheck)
            .then(resp => {
                let expandedRowsAux = [];
                this.setState({disabledSearchButton:true});
                if (resp.length === 0) {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: 'No existen datos'
                    });
                    this.setState({
                        dataReport: [],
                        expandedRows: [],
                    });
                    this.loading(false);
                } else {
                    if (this.state.filters.guaranteeCheck) {
                        resp.map((row) => {
                            return (row.guaranteeIntradayReportList.length === 0 ? '' : expandedRowsAux.push(row));
                        });
                    }
                    this.setState({
                        dataReport: resp,
                        expandedRows: expandedRowsAux,
                    });
                    this.loading(false);
                }
            });

    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                consultDate:
                    this.state.filters.startDate.getFullYear() + "-" +
                    ("0" + (this.state.filters.startDate.getMonth() * 1 + 1)).slice(-2) + "-" +
                    ("0" + this.state.filters.startDate.getDate()).slice(-2),
                institucionId: localStorage.getItem("institution") === "Interno" ? 0 : localStorage.getItem("institutionId"),
                withGuarantee: this.state.filters.guaranteeCheck,
                withIsin: this.state.filters.isinColumn,
            };

            switch (this.state.typeDocument) {
                case "CSV":
                    this.reportsService.getIntradayReportCSV(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getIntradayReportPdf(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "Excel":
                    this.reportsService.getIntradayReportXls(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataReport, isLoading, columnSelected, expandedRows,
            filters, exportOptions, disabledSearchButton
        } = this.state;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           sortable={true}
                           body={col.body ? col.body : ''}
            />;
        });

        return <ActiveGuaranteesDetailWithLoanInFlowView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            columnSelected={columnSelected}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            onChangeFilters={this.onChangeFilters}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataReport={this.getDataReport}
            clearFilters={this.clearFilters}
        />
    }
};